import clsx from 'clsx';
import React from 'react';

import { TextInput } from '../Input/TextInput';

type Props = Parameters<typeof TextInput>[0];

export const ModalTextInput = React.forwardRef<HTMLInputElement, Props>(
  ({ disabled, className, 'data-testid': dataTestId, ...props }, ref) => (
    <TextInput
      ref={ref}
      size="inherit"
      border={props.border ?? false}
      height="h-full"
      width={props.width ?? 'w-full'}
      padding="p-f0"
      background="bg-main-200"
      {...props}
      disabled={disabled}
      className={clsx(
        'text-ellipsis',
        disabled
          ? 'hover:cursor-disabled hover:bg-main-200'
          : 'hover:cursor-text hover:bg-negative',
        'text-f2',
        props.border && 'border-main-300 border-[0.5px]',
        className
      )}
      data-lpignore
      data-1p-ignore
      data-form-type="other"
      data-testid={dataTestId}
    />
  )
);

ModalTextInput.displayName = 'ModalTextInput';
